// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';

export const updateClaimIsNonTracked = isNonTracked =>
    dispatch => {

        dispatch({
            isNonTracked,
            type: actions.UPDATE_CLAIM_PIP_IS_NON_TRACKED
        });

    };



// WEBPACK FOOTER //
// ./src/claim/pip/action-creators/update-claim-is-non-tracked.js